import { render, staticRenderFns } from "./MemberItem.vue?vue&type=template&id=084c8374&scoped=true&"
import script from "./MemberItem.vue?vue&type=script&lang=js&"
export * from "./MemberItem.vue?vue&type=script&lang=js&"
import style0 from "./MemberItem.vue?vue&type=style&index=0&id=084c8374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c8374",
  null
  
)

export default component.exports